import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { share } from 'rxjs/operators';

export class Breadcrumb {
  name: string;
  param: number;
  active?: boolean;
}
export class EditPassword {
  token: string;
  password: string;
  new_password: string;
}
@Injectable()
export class ReportService {
  private httpOptions = {
    headers: new HttpHeaders({
        'Accept': 'text/html',
        'Content-Type': 'application/json'
    }),
    responseType: 'text'
};
  breadcrumb: Breadcrumb[] = [];
  breadcrumb$ = new Subject<Breadcrumb>();
  updateBreadcrumb$ = new Subject<number>();
  updateBreadcrumbs$ = new Subject<Breadcrumb[]>();
  constructor(private http: HttpClient) { }
  addBreadcrumb(item: Breadcrumb) {
    //console.log('BC',this.breadcrumb);

    let r=this.breadcrumb.findIndex(_item => _item.name==item.name);

    if(r==-1) {
      item.active = false;
      this.breadcrumb.forEach(_item => _item.active = true);
      item.name = item.name.replace('<br/>','-');
      this.breadcrumb.push(item);
      this.breadcrumb$.next(item);
    }
  }
  updateBreadcrumb(index: number) {
    this.breadcrumb = this.breadcrumb.filter(item => item.param <= index);
    this.breadcrumb.forEach((item, index) => {
      item.active = true;
      if(index==this.breadcrumb.length-1) {
        item.active = false;
      }
      this.breadcrumb$.next(item);
    });
    this.updateBreadcrumb$.next(index);
  }
  updateNameBreadcrumb(newName: string, index: number) {
    this.breadcrumb.forEach(item => {
      if(item.param == index) {
        item.name = newName;
      }
    });
    this.updateBreadcrumbs$.next(this.breadcrumb);
  }
  breadcrumbObserver(): Observable<Breadcrumb> {
    return this.breadcrumb$.asObservable().pipe(
      share()
    );
  }
  updateBreadcrumbObserver(): Observable<number> {
    return this.updateBreadcrumb$.asObservable().pipe(
      share()
    );;
  }
  updateBreadcrumbsObserver(): Observable<Breadcrumb[]> {
    return this.updateBreadcrumbs$.asObservable().pipe(
      share()
    );;
  }
  getCharts(index): Observable<any> {
    return this.http.get('https://rest.vipfe.gob.bo/reportes/grafico/' + index);
  }
  login(username: string, password: string): Observable<any> {
    return this.http.post('https://sisin.vipfe.gob.bo/bsn/ktr1/sbs_bd_reportes/mod_reportesFinancieros/rpt_login.php', {username: username, password: password});
  }
  logout(token): Observable<any> {
    return this.http.post('https://sisin.vipfe.gob.bo/bsn/ktr1/sbs_bd_reportes/mod_reportesFinancieros/rpt_cerrar_sesion.php', {token: token});
  }
  editPassword(data: EditPassword): Observable<any> {
    return this.http.post('https://sisin.vipfe.gob.bo/bsn/ktr1/sbs_bd_reportes/mod_reportesFinancieros/rpt_cambiar_clave.php', data);
  }
  getData(): Observable<any> {
    return this.http.get('https://rest.vipfe.gob.bo/reportes/detalleInstitucional');
  }
  getDataByUrl(url): Observable<any> {
    return this.http.get(url);
  }
  getData1(): Observable<any> {
    return this.http.get('https://sisin.vipfe.gob.bo/bsn/ktr1/sbs_bd_reportes/mod_reportesFinancieros/rpt_resumen_tipo_recurso_json.php?gestion=2005&cod_tipo=1&codigo_barra=MPD-VIPFE%20EVOL-REC&tipo_dato=JSON');
  }
  getDetalleTablaContratacion(): Observable<any> {
    return this.http.get('https://rest.vipfe.gob.bo/reportes/detalleTablaContratacion');
  }
  getBreadcrumbs() {
    return this.breadcrumb;
  }

  getTipoEntidad(): Observable<any> {
    return this.http.get('https://rest.vipfe.gob.bo/sisin/gestionTipoEntidad');
  }
  getEntidad(codigo): Observable<any> {
    return this.http.get('https://rest.vipfe.gob.bo/sisin/gestionEntidad?codTipoEntidad='+codigo);
  }



  getProyectos(params) {
    return this.http.get('https://rest.vipfe.gob.bo/reportes/proyectos',  { params: params }).toPromise()
    .then((data: any) => {
        return {
            data: data.data,
            totalCount: data.total
        };
    })
    .catch(error => {
      throw 'Data Loading Error'
    });
  }

  getProyectosGeneral(params) {
    return this.http.get('https://rest.vipfe.gob.bo/reportes/proyectosGeneral',  { params: params }).toPromise()
    .then((data: any) => {
        return {
            data: data.data,
            totalCount: data.total
        };
    })
    .catch(error => {
      throw 'Data Loading Error'
    });
  }

  getGestion(): Observable<any> {
    return this.http.get('https://rest.vipfe.gob.bo/reportes/gestion');
  }

  getListaReportesPorOpcion(opcion) {
    return this.http.get('https://rest.vipfe.gob.bo/reportes/listaReportesPorOpcion?opcion='+opcion).toPromise()
    .then((data: any) => {
        return {
            data: data,
        };
    })
    .catch(error => {
      throw 'Data Loading Error'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/report/report.service.ts